import CardCount from "src/components/CardCount";
import PageContainer from "../../components/routes/PageContainer";
import { useContext, useEffect, useState } from "react";
import { useDebounce } from "src/hooks/useDebounce";
import { Notification } from "@rio-cloud/rio-uikit";
import { Dialog, TableTrips } from "@components";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  fetchCanceledTrip,
  fetchTripsList,
  sendStatusSchulingTrip,
} from "src/services/trips";
import ConfirmationDialog from "@rio-cloud/rio-uikit/ConfirmationDialog";
import { getFollowers, getFollowings } from "src/services/social";
import { Client } from "@amityco/ts-sdk";
import { useAppSelector } from "@store";
import {createCheckpoint, deleteCheckpoint, getAllCheckpoints, updateCheckpoint} from "../../services/checkpoint";
import TableCheckpoints from "../../components/TableCheckpoints";
import {CheckpointResponse} from "../../types/checkpoint";

const CheckpointsScreen = () => {
  const profile = useAppSelector((state) => state.login.userProfile);
  const [searchValue, setSearchValue] = useState("");
  const [sort, setSort] = useState("desc");
  const [fieldSort, setFieldSort] = useState("name");
  const [page, setPage] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [pages, setPages] = useState(1);
  const [show, setShow] = useState(false);
  const [idDelete, setIdDelete] = useState<undefined | string>("");
  const [dashboard, setDashboard] = useState({
    checkpoints: 0,
  });

  const [filterByType, setFilterByType] = useState<string>('ALL');
  const debouncedSearch = useDebounce(searchValue, 400);

  const [startDate, setStartDate] = useState<string | undefined>(undefined);
  const [endDate, setEndDate] = useState<string | undefined>(undefined);

  const navigate = useNavigate();
  const [search] = useSearchParams();

  const [checkpoints, setCheckpoints] = useState<CheckpointResponse[]>([]);
  const [checkpointToEdit, setCheckpointToEdit] = useState<CheckpointResponse | null>(null);

  const initialData = async (signal?: AbortSignal) => {
    try {
      const result = await getAllCheckpoints();
      if (result) {
        setCheckpoints(result);
        setDashboard({checkpoints: result.length});
        setPages(1);
      }
    } catch (error) {
      if ((error as any).name !== "CanceledError")
        Notification.error("Não foi possível buscar os checkpoints.");
    }
  };

  const handleUpdateCheckpoint = (id?: string) => {
    const checkpoint = checkpoints.find(c => c.id === id);
    if (!checkpoint) return;

    setCheckpointToEdit(checkpoint);
    setOpenCheckpointModal(true);
  };

  const handleDelete = (id?: string) => {
    if (!id) return;
    setIdDelete(id);
    setShow(true);
  };

  const confirmDelete = async () => {
    if (!idDelete) return;

    try {
      await deleteCheckpoint(idDelete);
      Notification.success("Checklist excluído com sucesso!");
      setShow(false);
      setIdDelete(undefined);
      await initialData();
    } catch (error) {
      Notification.error("Erro ao excluir o checklist.");
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    initialData(signal);
    return () => {
      controller.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, debouncedSearch, sort, filterByType, startDate, endDate]);

  const handleDownload = () => {
    console.log("donwload");
  };

  const handleSelectFilterByType = (type: string) => {
    setPage(1);
    setFilterByType(prev => {
      if (prev === type) {
        return type === 'ALL' ? 'ALL' : 'ALL';
      }
      return type;
    });
  };

  const handleDateFilterChange = (start?: string, end?: string) => {
    setStartDate(start);
    setEndDate(end);
  };

  const [openCheckpointModal, setOpenCheckpointModal] = useState(false);

  const handleOpenCheckpointModal = () => {
    setOpenCheckpointModal(true);
  };

  const handleCloseCheckpointModal = () => {
    setOpenCheckpointModal(false);
    setCheckpointToEdit(null);
  };

  return (
    <PageContainer>
      <div style={{display: "flex", gap: 24}}>
        <div style={{width: 400}}>
          <CardCount
            isActive={filterByType === 'ALL'}
            onClick={() => handleSelectFilterByType('ALL')}
            borderColor="#00C2DF"
            label="TODOS OS CHECKPOINTS"
            value={dashboard.checkpoints}
          />
        </div>
      </div>
        {/*<div style={{display: "flex", gap: 20}}>
        <CardCount
          isActive={filterByType === 'ALL'}
          onClick={() => handleSelectFilterByType('ALL')}
          borderColor="#00C2DF"
          label="TODAS AS VIAGENS"
          value={dashboard.allTrips}
        />

        <CardCount
          isActive={filterByType === 'ACCEPTED'}
          onClick={() => handleSelectFilterByType('ACCEPTED')}
          borderColor="#5CB85C"
          label="VIAGENS AGENDADAS"
          value={dashboard.scheduled}
        />

        <CardCount
          isActive={filterByType === 'PROPOSED'}
          onClick={() => handleSelectFilterByType('PROPOSED')}
          borderColor="#FF8E3C"
          label="NOVAS PROPOSTAS"
          value={dashboard.new}
        />

        <CardCount
          isActive={filterByType === 'PENDING'}
          onClick={() => handleSelectFilterByType('PENDING')}
          borderColor="#D0D8DE"
          label="ACEITE PENDENTE"
          value={dashboard.pending}
        />

        <CardCount
          isActive={filterByType === 'REFUSED'}
          onClick={() => handleSelectFilterByType('REFUSED')}
          borderColor="#D90000"
          label="VIAGENS RECUSADAS"
          value={dashboard.refused}
        />

        <CardCount
          isActive={filterByType === 'CANCELED'}
          onClick={() => handleSelectFilterByType('CANCELED')}
          borderColor="#D90000"
          label="VIAGENS CANCELADAS"
          value={dashboard.canceled}
        />
      </div>*/}

        {/*<TableTrips
        usersAmity={usersAmity}
        followers={followers}
        pages={pages}
        handleDownload={handleDownload}
        handleSort={(dir, field) => {
          setSort(dir);
          setFieldSort(field);
        }}
        routes={routes}
        viewType="TABLE"
        page={page}
        handleCreateRoute={handleOpenModal}
        handleUpdateRoute={handleUpdateRoute}
        handleSearchValueChange={(text) => setSearchValue(text)}
        searchValue={searchValue}
        handleScheduleAccept={(id) => handleSchedulingActionDate("ACCEPT", id)}
        handleScheduleRefused={(id) => handleSchedulingActionDate("REFUSE", id)}
        handleCancel={(id) => {
          setIdDelete(id);
          setShow(true);
        }}
        handlePage={(page) => {
          setPage(page);
        }}
        onDateFilterChange={handleDateFilterChange}
        handleCreateCheckpoint={handleOpenCheckpointModal}
      />*/}
        {/* <TableCheckpoints
          viewType={"TABLE"}
          rows={checkpoints}
          pages={pages}
          searchValue={searchValue}
          page={page}
          handleSearchValueChange={(text) => setSearchValue(text)}
          handleDownload={handleDownload}
          handlePage={(page) => {
            setPage(page);
          }}
          handleSort={(dir, field) => {
            setSort(dir);
            setFieldSort(field);
          }}
          handleCreateCheckpoint={handleOpenCheckpointModal}
          handleDelete={handleDelete}
          handleUpdateCheckpoint={handleUpdateCheckpoint}
        /> */}

        <ConfirmationDialog
          show={show}
          title="Confime a Exclusão"
          content="Tem certeza que deseja excluir o checkpoint?"
          onClickConfirm={confirmDelete}
          onClickCancel={() => setShow(false)}
          cancelButtonText="Voltar"
          confirmButtonText={
            <>
              <span>Confirmar</span>
            </>
          }
          useOverflow
        />
        <Dialog.AddCheckpoint
          open={openCheckpointModal}
          onClose={handleCloseCheckpointModal}
          onCreateCheckpoint={async (checkpointData) => {
            try {
              if (checkpointToEdit) {
                await updateCheckpoint(checkpointToEdit.id, checkpointData);
                Notification.success("Checklist de parada atualizado com sucesso!");
              } else {
                await createCheckpoint(checkpointData);
                Notification.success("Checklist de parada criado com sucesso!");
              }
              // Limpa o estado antes de fechar o modal
              setCheckpointToEdit(null);
              setOpenCheckpointModal(false);
              await initialData();
            } catch (error) {
              Notification.error("Erro ao criar checklist.");
            }
          }}
          checkpointToEdit={checkpointToEdit}
        />
    </PageContainer>
);
};

export default CheckpointsScreen;
